import {
  LEAK_STATUS,
  CONNECTIVITY_STATUS,
  BATTERY_STATUS,
  ONBOARDING_STATUS,
  ANALYSING_STATUS
} from './deviceStatus'

// LEAK
const LEAK_NONE = 'static/img/leak_none_icon.svg'
const LEAK_NO_SIG = 'static/img/leak_active_no signal.svg'
const LEAK_SUSPECTED = 'static/img/leak_suspect.svg'
const LEAK_ACTIVE = 'static/img/leak_active_icon.svg'
const REPAIR_FAILED = 'static/img/repair_failed.svg'
const REPAIR_COMPLETE = 'static/img/repair_complete.svg'

// CONNECTIVITY
const SIGNAL_NONE = 'static/img/signal_none_icon.svg'
const SIGNAL_LOW = 'static/img/signal_low_icon.svg'
const SIGNAL_GOOD = 'static/img/signal_good_icon.svg'
const SIGNAL_UNKNOWN = 'static/img/signal_unknown_icon.svg'

// BATTERY
const BATTERY_LOW = 'static/img/battery_low_icon.svg'
const BATTERY_GOOD = 'static/img/battery_good_icon.svg'
const BATTERY_UNKNOWN = 'static/img/battery_unknown_icon.svg'

// ONBOARDING
const INSTALL_REGISTERED = 'static/img/install_registered_icon.svg'
const INSTALL_COMPLETE = 'static/img/install_complete_icon.svg'

// ANALYSING MODE
const ANALYSINGMODE_HIGH_USAGE_ONLY = 'static/img/analysing_mode_icon.svg'

export const LEAK_ICON = {
  [LEAK_STATUS.NULL]: LEAK_NO_SIG,
  [LEAK_STATUS.LEAK]: LEAK_ACTIVE,
  [LEAK_STATUS.NO_LEAK]: LEAK_NONE,
  [LEAK_STATUS.ENG_VISIT_NO_LEAK]: LEAK_SUSPECTED,
  [LEAK_STATUS.SUSPECT]: LEAK_SUSPECTED,
  [LEAK_STATUS.LEAK_ENG_VISIT]: LEAK_ACTIVE,
  [LEAK_STATUS.REPAIRED]: REPAIR_COMPLETE,
  [LEAK_STATUS.CUST_REPAIRED]: REPAIR_COMPLETE,
  [LEAK_STATUS.CUST_REPAIRED_FAILED]: REPAIR_FAILED,
  [LEAK_STATUS.FAILED_REPAIR]: REPAIR_FAILED,
  [LEAK_STATUS.UNKNOWN_NO_SIG]: LEAK_NO_SIG,
  [LEAK_STATUS.UNKNOWN_LOST_SIG]: LEAK_NO_SIG,
  [LEAK_STATUS.UNKOWN]: LEAK_NO_SIG
}

export const CONNECTIVITY_ICON = {
  [CONNECTIVITY_STATUS.NULL]: SIGNAL_UNKNOWN,
  [CONNECTIVITY_STATUS.NO_SIGNAL]: SIGNAL_NONE,
  [CONNECTIVITY_STATUS.HAS_SIGNAL]: SIGNAL_GOOD,
  [CONNECTIVITY_STATUS.LOW_SIGNAL]: SIGNAL_LOW,
  [CONNECTIVITY_STATUS.LOST_SIGNAL]: SIGNAL_NONE
}

export const BATTERY_ICON = {
  [BATTERY_STATUS.NULL]: BATTERY_UNKNOWN,
  [BATTERY_STATUS.GOOD_BATTERY]: BATTERY_GOOD,
  [BATTERY_STATUS.LOW_BATTERY]: BATTERY_LOW,
  [BATTERY_STATUS.NO_BATTERY]: BATTERY_UNKNOWN,
  [BATTERY_STATUS.NO_SIGNAL]: BATTERY_UNKNOWN
}

export const ANALYSINGMODE_ICON = {
  [ANALYSING_STATUS.HIGH_USAGE_ONLY]: ANALYSINGMODE_HIGH_USAGE_ONLY
}

export const CUSTOMER_ICON = {
  [ONBOARDING_STATUS.PAIRED]: INSTALL_REGISTERED,
  [ONBOARDING_STATUS.AWAITING_TAP]: INSTALL_REGISTERED,
  [ONBOARDING_STATUS.AWAITING_LEAK]: INSTALL_COMPLETE,
  [ONBOARDING_STATUS.COMPLETE]: INSTALL_COMPLETE
}
